import React from 'react';
import DogDisplayPage from './DogDisplayPage';
import { WidePhoto, TallPhoto, SquarePhoto } from './Constants';
import hades1 from './assets/images/hades/hades1.jpg';
import hades2 from './assets/images/hades/hades2.jpg';
import hades3 from './assets/images/hades/hades3.jpg';
import hades4 from './assets/images/hades/hades4.jpg';
import hades5 from './assets/images/hades/hades5.jpg';
import hades6 from './assets/images/hades/hades6.jpg';
import hades7 from './assets/images/hades/hades7.jpg';
import hades8 from './assets/images/hades/hades8.jpg';
import hades9 from './assets/images/hades/hades9.jpg';
import hades10 from './assets/images/hades/hades10.jpg';
import hades11 from './assets/images/hades/hades11.jpg';
import hades12 from './assets/images/hades/hades12.jpg';
import hades13 from './assets/images/hades/hades13.jpg';
import hades14 from './assets/images/hades/hades14.jpg';
import hades15 from './assets/images/hades/hades15.jpg';
import hades16 from './assets/images/hades/hades16.jpg';
import hades17 from './assets/images/hades/hades17.jpg';
import hades18 from './assets/images/hades/hades18.jpg';


const photos = [
    { src: hades1, ...WidePhoto },
    { src: hades2, ...WidePhoto },
    { src: hades3, ...TallPhoto },
    { src: hades4, ...TallPhoto },
    { src: hades5, ...TallPhoto },
    { src: hades6, ...SquarePhoto },
    { src: hades7, ...SquarePhoto },
    { src: hades8, ...TallPhoto },
    { src: hades9, ...TallPhoto },
    { src: hades10, ...TallPhoto },
    { src: hades11, ...TallPhoto },
    { src: hades12, ...TallPhoto },
    { src: hades13, ...TallPhoto },
    { src: hades14, ...SquarePhoto },
    { src: hades15, ...TallPhoto },
    { src: hades16, ...SquarePhoto },
    { src: hades17, ...TallPhoto },
    { src: hades18, ...TallPhoto },
];

const Hades = () => {
    return (
        <DogDisplayPage photos={photos}>
            <h1 className="male">
                <i className="far fa-mars"></i>
                Hades
                <span className="stud">Available for Stud service to approved Bitches</span>
            </h1>
            <table className="dog-chart">
                <tbody>
                    <tr>
                        <td><span className="title">Name</span>LUNANOVA'S LEGENDARY KING OF THE UNDERWORLD</td>
                        <td><span className="title">Owner</span>CAROLYNNE ISSA</td>
                        <td><span className="title">CKC Registration</span>#JW4136937</td>
                    </tr>
                    <tr>
                        <td><span className="title">Sire</span>CH LUNANOVA'S CHILKO FREESTONE</td>
                        <td><span className="title">Dam</span>CH SKIPNSTONES GODDESS AT LUNANOVA JWD</td>
                    </tr>
                    <tr>
                        <td><span className="title">Coat Type</span>WAVY</td>
                        <td><span className="title">Coat Colour</span>BLACK WITH WHITE MARKINGS</td>
                    </tr>
                    <tr>
                        <td><span className="title">CAER</span>NORMAL</td>
                        <td><span className="title">CDDY/IVVD</span>NORMAL</td>
                        <td><span className="title">EOPRA</span>NORMAL</td>
                    </tr>
                    <tr>
                        <td><span className="title">GM-1</span>normal</td>
                        <td><span className="title">Improper Coat</span>normal</td>
                        <td><span className="title">JDCM</span>normal</td>
                        <td><span className="title">MICROPHTHALMIA SYNDROME</span>normal</td>
                    </tr>
                    <tr>
                        <td><span className="title">OFA Hips</span>EXCELLENT (ELBOWS NORMAL)</td>
                        <td><span className="title">PRA</span>normal</td>
                    </tr>
                </tbody>
            </table>
        </DogDisplayPage>
    )
}
export default Hades;
